import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachSendEntity } from './outreach-send.entity';

@Entity('_outreach_interaction')
export class OutreachInteractionEntity extends BaseEntity {
	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('enum', {
		name: '_interaction_type',
		enum: [
			'delivered',
			'opened',
			'clicked',
			'bounced',
			'complained',
			'unsubscribed',
			'answered',
			'voicemail',
			'busy',
			'no_answer',
			'call_completed',
			'call_failed',
		],
	})
	public interactionType!:
		| 'delivered'
		| 'opened'
		| 'clicked'
		| 'bounced'
		| 'complained'
		| 'unsubscribed'
		| 'answered'
		| 'voicemail'
		| 'busy'
		| 'no_answer'
		| 'call_completed'
		| 'call_failed';

	@Column('timestamp', {
		name: '_interaction_date',
		default: () => 'CURRENT_TIMESTAMP',
	})
	public interactionDate!: Date;

	@Column('varchar', { name: '_ip_address', nullable: true, length: 45 })
	public ipAddress!: string | null;

	@Column('text', { name: '_user_agent', nullable: true })
	public userAgent!: string | null;

	@Column('text', { name: '_clicked_url', nullable: true })
	public clickedUrl!: string | null;

	@Column('varchar', { name: '_bounce_type', nullable: true, length: 50 })
	public bounceType!: string | null;

	@Column('text', { name: '_bounce_reason', nullable: true })
	public bounceReason!: string | null;

	@Column('int', { name: '_call_duration', nullable: true })
	public callDuration!: number | null;

	@Column('text', { name: '_call_recording_url', nullable: true })
	public callRecordingUrl!: string | null;

	@Column('text', { name: '_notes', nullable: true })
	public notes!: string | null;

	@Column('json', { name: '_metadata', nullable: true })
	public metadata!: object | null;

	@ManyToOne(
		() => OutreachSendEntity,
		(outreachSend) => outreachSend.outreachInteractions,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__outreach_send__id', referencedColumnName: 'id' }])
	public fkOutreachSend!: OutreachSendEntity;
}
